// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"bev_a bhs_tr","StrollerBoxWidget__imageCounselling":"bev_b bhs_kg"};